export default __webpack_public_path__ + "static/media/sqlserver.0de8bfd4.svg";